import Box from '@mui/material/Box';
import { SwitchCategoryButton } from './SwitchCategoryButton';

interface CategoryButtonProps {
    category: string;
    selectCategory: (cat: string) => void;
    categories: CategoryMenu[];
}

export interface CategoryMenu {
    name: string;
    label: string;
}

export default function CategoryButtonMenu({ category, selectCategory, categories }: CategoryButtonProps) {

    const categoryItems = categories.map(  ( {name, label}, i ) => {
        return <SwitchCategoryButton key={i} onClick={() => selectCategory(name)} active={category === name} name={name}>{label}</SwitchCategoryButton>
    });

    return (
        <Box sx={{  pl: 0, pr: 0, display: 'flex' }}>
            <Box sx={{ position: 'relative', pr: 0, pl: 0, pb: 0, backgroundColor: 'action.active',
            borderRadius: 2, flexGrow: 0, justifyContent: 'space-around', display: 'flex' }}
            >
                {categoryItems}
            </Box>
        </Box>

    )
}
